module.exports = __webpack_public_path__ + "img/Watney_Hero.779d4c46.jpg";